import { NavLink, Outlet } from "react-router-dom";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import { useAuth } from "@/contexts/AuthContext";
import { Users, Mic, Award, BookOpen, BarChart3, Layers, FileImage, MessageSquare, Megaphone, ScrollText, Building2, Languages, UserPlus } from "lucide-react";

// Each nav item declares which roles can see it. Support sees the same
// CMS/Users/Recitations sections as Admin; Teacher only sees grading
// surfaces (Users read-only + Recitations review).
const NAV = [
  { to: "users", label: "Users", icon: Users, roles: ["admin", "support", "mentor"] },
  { to: "modules", label: "Modules", icon: Layers, roles: ["admin", "support", "translator"] },
  { to: "recitations", label: "Recitations", icon: Mic, roles: ["admin", "support", "mentor"] },
  { to: "certificates", label: "Certificates", icon: Award, roles: ["admin", "support"] },
  { to: "cert-templates", label: "Cert Templates", icon: FileImage, roles: ["admin", "support"] },
  { to: "programs", label: "Programs", icon: BookOpen, roles: ["admin", "support"] },
  { to: "feedback", label: "Feedback", icon: MessageSquare, roles: ["admin", "support"] },
  { to: "organizations", label: "Organizations", icon: Building2, roles: ["admin", "support"] },
  { to: "broadcast", label: "Broadcast", icon: Megaphone, roles: ["admin", "support"] },
  { to: "analytics", label: "Analytics", icon: BarChart3, roles: ["admin"] },
  { to: "audit-log", label: "Audit Log", icon: ScrollText, roles: ["admin"] },
  { to: "translations", label: "Translations", icon: Languages, roles: ["admin", "translator"] },
  { to: "translator-applications", label: "Translator Applications", icon: UserPlus, roles: ["admin", "support"] },
];

export default function AdminShell() {
  const { user } = useAuth();
  const role = user?.role || "admin";
  const visible = NAV.filter((n) => n.roles.includes(role));
  return (
    <div className="min-h-screen flex flex-col" data-testid="admin-shell">
      <Header />
      <main className="flex-1 max-w-[1280px] mx-auto w-full px-5 sm:px-8 py-8 grid lg:grid-cols-[220px_1fr] gap-8">
        <aside className="lg:sticky lg:top-20 lg:self-start">
          <div className="text-xs uppercase tracking-[0.22em] text-[#4B5563] mb-3">
            {role === "admin" ? "Admin" : role === "support" ? "Support" : role === "translator" ? "Translator" : "Mentor"}
          </div>
          <nav className="rounded-2xl bg-white border border-[#E7E0D2] overflow-hidden">
            {visible.map((n) => (
              <NavLink
                key={n.to} to={n.to}
                data-testid={`adminnav-${n.to}`}
                className={({ isActive }) =>
                  `flex items-center gap-3 px-4 py-3 text-sm border-b border-[#E7E0D2] last:border-b-0 transition ${
                    isActive ? "bg-[#FFF7ED] text-[#064E3B] font-medium" : "text-[#4B5563] hover:bg-[#FDFBF7]"
                  }`
                }>
                <n.icon className="w-4 h-4" /> {n.label}
              </NavLink>
            ))}
          </nav>
        </aside>
        <div className="min-w-0">
          <Outlet />
        </div>
      </main>
      <Footer />
    </div>
  );
}
